import {ListTabExtension} from "./ListTabExtension";
import Blockquote from "@tiptap/extension-blockquote";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Heading from "@tiptap/extension-heading";
import TextAlign from "@tiptap/extension-text-align";
import {TextColorExtension} from "./TextColorExtension";
import {BulletList, ListItem, OrderedList} from "@tiptap/extension-list";
import StarterKit from "@tiptap/starter-kit";

export const richTextExtensions = [
  StarterKit.configure({
    bulletList: false,
    orderedList: false,
    listItem: false,
    heading: false,
    link: false,
    // Worden hieronder los toegevoegd; anders staan ze dubbel geregistreerd.
    blockquote: false,
    horizontalRule: false,
    codeBlock: false,
  }),
  ListItem,
  BulletList.configure({
    keepMarks: true,
    keepAttributes: true,
  }),
  OrderedList,
  TextAlign.configure({
    types: ["heading", "paragraph"],
  }),
  Heading.configure({
    levels: [1, 2, 3]
  }),
  HorizontalRule,
  Blockquote,
  TextColorExtension,
  ListTabExtension,
  ListTabExtension,
]
